import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Module 10 Quiz",
    duration: 20
};

export const module10Questions: QuizQuestion[] = [
    {
        id: "M10-001",
        moduleId: "module-10",
        category: "Ownership",
        text: "Under Ohio vehicle owner guidelines, what is the typical immediate depreciation rate of a brand-new vehicle the moment it is driven off the dealership lot?",
        options: [
            "Approximately 5% of its total retail value",
            "Approximately 10% of its total retail value",
            "Approximately 20% of its total retail value",
            "Approximately 35% of its total retail value"
        ],
        correctAnswer: 2,
        scenario: "A brand-new vehicle loses approximately 20% of its total retail value the exact moment it is driven off the dealership lot.",
        explanation: ""
    },
    {
        id: "M10-002",
        moduleId: "module-10",
        category: "Ownership",
        text: "When financing a vehicle purchase through a lender, what insurance coverage are you typically contractually required to carry until the loan principal is fully paid?",
        options: [
            "Basic Ohio bodily injury liability coverage only",
            "Property damage liability coverage only",
            "Full coverage (both comprehensive and collision coverage)",
            "Uninsured motorist coverage only"
        ],
        correctAnswer: 2,
        scenario: "Lenders contractually require full coverage (both collision and comprehensive) to safeguard their financial stake in the vehicle until the principal loan amount is fully repaid.",
        explanation: ""
    },
    {
        id: "M10-003",
        moduleId: "module-10",
        category: "Ownership",
        text: "Before finalizing the purchase of a pre-owned vehicle, what is considered the ultimate safety and financial safeguard for a buyer?",
        options: [
            "Relying entirely on the vehicle history report (e.g., CarFax) provided by the seller",
            "Investing in a certified, independent Pre-Purchase Inspection (PPI) performed by a neutral mechanic",
            "Accepting the vehicle 'As-Is' based on a standard visual inspection of the exterior panels",
            "Conducting a short test drive at low speeds around a single city block"
        ],
        correctAnswer: 1,
        scenario: "You are preparing to purchase a used vehicle from a private seller and want to protect yourself from hidden mechanical or safety defects.",
        explanation: "Investing in a certified, independent Pre-Purchase Inspection (PPI) by a neutral mechanic is the most secure way to verify the structural, suspension, and engine health of a used vehicle."
    },
    {
        id: "M10-004",
        moduleId: "module-10",
        category: "Legal",
        text: "Under Ohio law, what is the legal requirement for signing a vehicle's Certificate of Title when purchasing from a private seller?",
        options: [
            "The seller must sign it in the presence of any licensed driver",
            "The seller must sign the title in the active presence of a certified Notary Public",
            "The seller can sign the title digitally before mailing it to the buyer",
            "The seller must sign the title in the presence of a Bureau of Motor Vehicles (BMV) clerk only"
        ],
        correctAnswer: 1,
        scenario: "No! Ohio law mandates that a private seller's signature MUST be signed in the active presence of a certified Notary Public. Without a notary's seal, the title transfer is completely void.",
        explanation: ""
    },
    {
        id: "M10-005",
        moduleId: "module-10",
        category: "Ownership",
        text: "Under Ohio law, what is the primary purpose and coverage scope of mandatory vehicle Liability Insurance?",
        options: [
            "It pays for the repairs to your own vehicle and your passenger's medical bills regardless of who caused the collision",
            "It strictly pays for the injuries and property damage you cause to others when you are at fault, paying nothing for your own vehicle or injuries",
            "It protects you against non-collision events such as theft, vandalism, animal strikes, or natural disasters",
            "It covers the loss of the vehicle's retail value over time due to natural wear and tear"
        ],
        correctAnswer: 1,
        scenario: "Mandatory Liability Insurance strictly pays for the injuries and property damage you cause to others when you are at fault in a collision. It pays $0 for your own injuries or repairs.",
        explanation: ""
    },
    {
        id: "M10-006",
        moduleId: "module-10",
        category: "Ownership",
        text: "What are the legally mandated minimum liability insurance limits for a motor vehicle operated in the state of Ohio?",
        options: [
            "10/20/10 ($10,000 per person, $20,000 per accident, $10,000 property damage)",
            "15/30/15 ($15,000 per person, $30,000 per accident, $15,000 property damage)",
            "25/50/25 ($25,000 per person, $50,000 per accident, $25,000 property damage)",
            "50/100/50 ($50,000 per person, $100,000 per accident, $50,000 property damage)"
        ],
        correctAnswer: 2,
        scenario: "Ohio legally mandates minimum liability limits of 25/50/25 ($25k bodily injury per person, $50k bodily injury per accident, $25k property damage).",
        explanation: ""
    },
    {
        id: "M10-007",
        moduleId: "module-10",
        category: "Ownership",
        text: "How does adjusting your policy’s deductible impact your monthly premium costs and financial responsibility during an insurance claim?",
        options: [
            "A higher deductible increases your monthly premium and lowers your out-of-pocket costs",
            "A higher deductible lowers your monthly premium but increases your out-of-pocket costs before insurance coverage begins paying",
            "A lower deductible lowers both your monthly premium and your out-of-pocket costs during a claim",
            "Adjusting the deductible has no impact on your monthly premium or out-of-pocket claim expenses"
        ],
        correctAnswer: 1,
        scenario: "A higher deductible directly lowers your monthly insurance premium, but increases the out-of-pocket amount you must personally pay before insurance covers a claim.",
        explanation: ""
    },
    {
        id: "M10-008",
        moduleId: "module-10",
        category: "Legal",
        text: "If you lend your insured vehicle to a friend in Ohio and they cause a collision, how is the insurance coverage and financial liability legally assigned?",
        options: [
            "Your friend's insurance policy is automatically primary and pays for all damages",
            "Your own auto insurance policy follows your vehicle and must pay for the damages, exposing your limits and premium rate",
            "Neither policy pays because the driver was not the registered owner of the vehicle",
            "The state of Ohio covers all damages through the BMV Financial Responsibility Fund"
        ],
        correctAnswer: 1,
        scenario: "Your own auto insurance policy follows your vehicle and must pay primary damages, exposing your own limits and potentially spiking your future premium rates.",
        explanation: ""
    },
    {
        id: "M10-009",
        moduleId: "module-10",
        category: "Ownership",
        text: "If your vehicle's oil pressure warning light glows steady on the dashboard while driving, what is the required emergency action?",
        options: [
            "Continue driving to the nearest gas station to check the oil level",
            "Immediately and safely pull off the roadway, stop, and turn off the engine to prevent catastrophic engine seizure",
            "Tap the accelerator pedal to see if the light resets itself",
            "Turn off your vehicle's air conditioning system to relieve load on the engine alternator"
        ],
        correctAnswer: 1,
        scenario: "If the oil pressure warning light glows steady on the dashboard while driving, you must immediately and safely pull off the roadway, stop the vehicle, and turn off the engine to prevent permanent engine seizure.",
        explanation: ""
    },
    {
        id: "M10-010",
        moduleId: "module-10",
        category: "Ownership",
        text: "Why is it extremely dangerous to check or open the radiator cap of a vehicle's cooling system while the engine is still hot or warm?",
        options: [
            "The radiator coolant will instantly freeze and block fluid circulation",
            "The cooling system is under extreme pressure, and releasing the cap can cause high-temperature steam and boiling liquid to explode outward, causing severe burns",
            "It will cause the engine oil to mix with the transmission fluid",
            "Opening the cap will instantly drain the battery's charge"
        ],
        correctAnswer: 1,
        scenario: "Opening the radiator cap of a hot engine is highly dangerous because the cooling system is under extreme pressure; releasing it can trigger a violent explosion of boiling coolant and steam, causing severe burns.",
        explanation: ""
    },
    {
        id: "M10-011",
        moduleId: "module-10",
        category: "Legal",
        text: "Under the standard safety jump-starting protocol for a dead battery, what is the precise order of connection for the jumper cable clamps?",
        options: [
            "Positive dead, positive good, negative good, and negative unpainted engine ground on the dead vehicle",
            "Negative good, negative dead, positive dead, and positive good",
            "Positive good, negative dead, positive dead, and negative unpainted ground",
            "Negative dead ground, positive good, negative good, and positive dead"
        ],
        correctAnswer: 0,
        scenario: "The standard jump-starting sequence is: connect red positive to dead battery (+), red positive to good battery (+), black negative to good battery (-), and finally black negative to an unpainted metal engine ground (-) on the dead vehicle.",
        explanation: ""
    },
    {
        id: "M10-012",
        moduleId: "module-10",
        category: "Legal",
        text: "What is the legally mandated minimum tire tread depth for a passenger vehicle operated on Ohio public roads?",
        options: [
            "1/32 of an inch",
            "1/16 of an inch (tread wear bars level with the tread)",
            "1/8 of an inch",
            "1/4 of an inch"
        ],
        correctAnswer: 1,
        scenario: "Under Ohio law, the legally mandated minimum tire tread depth is 1/16 of an inch. Tires with less tread must be replaced immediately to maintain safe traction and prevent hydroplaning.",
        explanation: ""
    },
    {
        id: "M10-013",
        moduleId: "module-10",
        category: "Safety",
        text: "When preparing for a short, local commute of less than one hour, what is a critical pre-departure fuel safety practice?",
        options: [
            "Only check fuel level when the low-fuel warning light illuminates",
            "Ensure the fuel level is sufficient to complete both the arrival and return legs of the round-trip",
            "Fill the tank to maximum capacity before every trip regardless of distance",
            "Verify that the engine oil is fully saturated with fuel elements"
        ],
        correctAnswer: 1,
        scenario: "Always verify before departing that your vehicle has sufficient fuel to complete both the arrival and the return legs of your round-trip commute, preventing high-risk fuel exhaustion emergencies.",
        explanation: ""
    },
    {
        id: "M10-014",
        moduleId: "module-10",
        category: "Safety",
        text: "Under standard safe long-distance driving guidelines, what is the recommended 'Rest-Stop Protocol' to combat driver fatigue and highway hypnosis?",
        options: [
            "Stop only when you feel physically unable to keep your eyes open",
            "Plan a 10-minute rest stop every 2 hours or 100 miles of driving to exit and stretch",
            "Drive for at least 6 consecutive hours before taking a brief hydration break",
            "Increase vehicle speed to arrive at your destination faster and reduce exposure to driving time"
        ],
        correctAnswer: 1,
        scenario: "To combat severe fatigue and highway hypnosis, you must plan a rest stop every 2 hours or 100 miles of consecutive driving to exit the vehicle, stretch, and restore mental focus.",
        explanation: ""
    },
    {
        id: "M10-015",
        moduleId: "module-10",
        category: "Safety",
        text: "How does cargo loading and weight distribution affect a vehicle's physics and handling stability during emergency maneuvers?",
        options: [
            "Piling heavy luggage high on a roof rack lowers the center of gravity and reduces body roll",
            "Placing heavy items low in the trunk over or forward of the rear axle preserves the center of gravity and vehicle stability",
            "Loading all weight at the extreme rear bumper optimizes front wheel traction and braking efficiency",
            "Storing heavy items loose in the passenger cabin increases passenger safety by buffering impact forces"
        ],
        correctAnswer: 1,
        scenario: "Heavy cargo should always be packed low in the trunk and forward of the rear axle to preserve the vehicle's low center of gravity and minimize high-speed emergency body roll.",
        explanation: ""
    },
    {
        id: "M10-016",
        moduleId: "module-10",
        category: "Safety",
        text: "Which winter survival tool is legally and practically recommended in Ohio for regaining wheel traction if your vehicle becomes stuck on slick ice or snow?",
        options: [
            "A bag of clay cat litter, sand, or coarse gravel to place directly under the drive tires",
            "Pouring boiling radiator coolant directly over the tread grooves",
            "Applying high-viscosity synthetic grease to the tire sidewalls",
            "A pneumatic impact wrench to lower the wheel offset"
        ],
        correctAnswer: 0,
        scenario: "Carrying a bag of coarse traction material, such as clay cat litter, sand, or gravel, provides critical tire grip if your vehicle becomes stuck on slick ice or packed snow.",
        explanation: ""
    },
    {
        id: "M10-017",
        moduleId: "module-10",
        category: "Safety",
        text: "What is the safety hazard associated with 'Automation Bias' when operating a vehicle equipped with Advanced Driver Assistance Systems (ADAS)?",
        options: [
            "The vehicle's fuel efficiency drops due to excessive computational power usage",
            "A dangerous cognitive state where a driver over-relies on automated safety systems and stops paying active attention to the roadway",
            "The vehicle automatically locks the doors and prevents manual exit during highway speeds",
            "It causes high-frequency sensor waves that interfere with local law enforcement radar devices"
        ],
        correctAnswer: 1,
        scenario: "Automation Bias is a highly dangerous cognitive state where the driver becomes complacent, over-relying on automated safety systems and dangerously stopping active visual scanning and road monitoring.",
        explanation: ""
    },
    {
        id: "M10-018",
        moduleId: "module-10",
        category: "Safety",
        text: "Under Ohio driving conditions, how does Electronic Stability Control (ESC) actively assist a driver in maintaining control of the vehicle?",
        options: [
            "It automatically steers the vehicle to the nearest service station when an engine fault code is triggered",
            "It continuously monitors steering and wheel speed, applying individual brakes to stabilize the vehicle if it begins to veer or slide",
            "It physically increases engine horsepower when driving up steep mountain inclines",
            "It overrides manual steering and completely park-assists the vehicle during highway slides"
        ],
        correctAnswer: 1,
        scenario: "ESC constantly monitors steering inputs and individual wheel rotation speeds, dynamically applying individual brakes to specific wheels to correct path drift and eliminate curve skid risks.",
        explanation: ""
    },
    {
        id: "M10-019",
        moduleId: "module-10",
        category: "Safety",
        text: "How does the integration of NASA-derived 'Neutral Body Posture' (NBP) research in modern vehicle seating enhance driver safety during long-distance trips?",
        options: [
            "It conforms the seat to the body's natural posture in zero gravity, optimizing blood flow and significantly reducing muscle fatigue",
            "It automatically ejects the driver from the vehicle cabin during high-speed roll-over crashes",
            "It generates high-frequency vibrations that physically shake the driver awake if their eyes close",
            "It permits the driver to lie completely flat and sleep while Adaptive Cruise Control operates"
        ],
        correctAnswer: 0,
        scenario: "Conforming seats to NASA-derived Zero-Gravity Neutral Body Posture support optimizes vascular blood flow and alignment, dramatically minimizing joint muscle strain and fatigue.",
        explanation: ""
    },
    {
        id: "M10-020",
        moduleId: "module-10",
        category: "Legal",
        text: "When weather conditions (such as Ohio winter slush, ice, or road salt) physically block ADAS sensors and cause them to shut down, who bears legal and physical responsibility?",
        options: [
            "The vehicle manufacturer who programmed the automated safety systems",
            "The licensed driver operating the vehicle, who must remain fully attentive and ready to assume complete manual control at all times",
            "The Ohio Department of Transportation (ODOT) for failing to keep highways completely clear of winter slush",
            "No one, as weather-induced sensor shutdowns legally absolve the driver of all collision liability"
        ],
        correctAnswer: 1,
        scenario: "The human driver remains 100% legally and physically responsible for the operation of the vehicle, regardless of whether seasonal road muck or winter slush disables automated sensors.",
        explanation: ""
    },
    {
        id: "M10-021",
        moduleId: "module-10",
        category: "Insurance",
        text: "What is the minimum legal liability insurance coverage required for bodily injury for one person under Ohio financial responsibility laws?",
        options: ["$10,000", "$25,000", "$50,000", "$100,000"],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Ohio financial responsibility laws mandate that every motor vehicle carry liability insurance with a minimum of $25,000 coverage for bodily injury or death of one person in any one accident.**",
        explanation: ""
    },
    {
        id: "M10-022",
        moduleId: "module-10",
        category: "Licensing",
        text: "Under Ohio GDL laws, what are the passenger restrictions for a 16-year-old licensed driver during the first 12 months?",
        options: [
            "They can carry unlimited passengers of any age",
            "They are limited to carrying no more than one non-family member passenger unless accompanied by a parent or legal guardian",
            "They can only carry family members under the age of 10",
            "No passengers are allowed at all"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Under GDL laws, licensed probationary drivers under the age of 17 are limited to carrying no more than one non-family passenger in their first 12 months, unless accompanied by a parent or legal guardian.**",
        explanation: ""
    },
    {
        id: "M10-023",
        moduleId: "module-10",
        category: "Registration",
        text: "How often must you renew your vehicle's license plate registration in Ohio?",
        options: [
            "Every 6 months",
            "Annually (every year) on or before your registration date",
            "Every 5 years",
            "Only when you buy a new car"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Ohio requires you to renew your vehicle registration annually (every year) on or before your specific expiration date, which is typically your birthday.**",
        explanation: ""
    },
    {
        id: "M10-024",
        moduleId: "module-10",
        category: "Ownership",
        text: "What is the legal purpose of a vehicle's Certificate of Title?",
        options: [
            "To prove active auto insurance coverage",
            "To serve as official, legal proof of vehicle ownership",
            "To act as your driver's license",
            "To log oil changes and maintenance records"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **The Certificate of Title is the official, legal government document that proves vehicle ownership. It lists the owner\\'s name, lienholders, and vehicle VIN.**",
        explanation: ""
    },
    {
        id: "M10-025",
        moduleId: "module-10",
        category: "Compliance",
        text: "What is the penalty in Ohio for failing to show proof of financial responsibility (insurance) when requested by a law enforcement officer?",
        options: [
            "A verbal warning only",
            "An immediate administrative driver's license suspension and vehicle impoundment fees",
            "A minor $10 fine",
            "Mandatory community service of 100 hours"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **In Ohio, failing to present proof of insurance when stopped by law enforcement leads to an immediate administrative suspension of your driver\\'s license and potential vehicle impoundment fees.**",
        explanation: ""
    }
];
